module.exports = __webpack_public_path__ + "img/logo.aac086c3.png";